import React from 'react';

export const RuRegionModal = {
  title: 'Region',
  body: (
    <div>
      <p>
        Regional boundaries defined as follows:
      </p>
      <p>
        <p>
          <ul>
            <li>87 - Alaska (including Aleutian Islands)</li>
            <li>40 - Black Sea and Caspian Sea</li>
            <li>74 - Caribbean Sea and Bermuda</li>
            <li>78 - Central Africa</li>
            <li>84 - China, North and South Korea, Philippines, Taiwan</li>
            <li>81 - E Australia, New Zealand, South Pacific Is.</li>
            <li>83 - E Indonesia and Malaysia</li>
            <li>75 - East Coast of United States and Canada</li>
            <li>76 - Gulf of Mexico</li>
            <li>80 - Hawaii, Johnston Atoll, Midway I</li>
            <li>60 - Indian Ocean (including west coast of Australia and W. Indonesia)</li>
            <li>85 - Japan</li>
            <li>86 - Kamchatka and Kuril Islands</li>
            <li>50 - Mediterranean Sea</li>
            <li>82 - New Caledonia, New Guinea, Solomon Is., Vanuatu</li>
            <li>73 - Northeast Atlantic Ocean</li>
            <li>72 - Northwest Atlantic Ocean</li>
            <li>30 - Red Sea and Persian Gulf</li>
            <li>70 - Southeast Atlantic Ocean</li>
            <li>71 - Southwest Atlantic Ocean</li>
            <li>77 - West Coast of Africa</li>
            <li>88 - West Coast of North and Central America</li>
            <li>89 - West Coast of South America</li>
          </ul>
        </p>
      </p>
    </div>
  ),
};
